var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBSignIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-sign-in",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-sign-in1",
    serifid: "iconB-sign-in"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.586,11l-3.293,-3.293c-0.39,-0.39 -0.39,-1.024 -0,-1.414c0.39,-0.39 1.024,-0.39 1.414,-0l5,5c0.19,0.19 0.293,0.444 0.293,0.707c-0,0.263 -0.103,0.517 -0.293,0.707l-5,5c-0.39,0.39 -1.024,0.39 -1.414,0c-0.39,-0.39 -0.39,-1.024 -0,-1.414l3.293,-3.293l-9.586,0c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l9.586,0Zm2.414,-7c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l1.2,0c1.925,0 2.881,0.061 3.616,0.436c0.753,0.383 1.365,0.995 1.748,1.748c0.375,0.735 0.436,1.691 0.436,3.616l0,8.4c0,1.925 -0.061,2.881 -0.436,3.616c-0.383,0.753 -0.995,1.365 -1.748,1.748c-0.735,0.375 -1.691,0.436 -3.616,0.436l-1.2,-0c-0.552,0 -1,-0.448 -1,-1c-0,-0.552 0.448,-1 1,-1l1.2,-0c1.436,-0 2.16,0.061 2.708,-0.218c0.376,-0.192 0.682,-0.498 0.874,-0.874c0.279,-0.548 0.218,-1.272 0.218,-2.708l0,-8.4c0,-1.436 0.061,-2.16 -0.218,-2.708c-0.192,-0.376 -0.498,-0.682 -0.874,-0.874c-0.549,-0.279 -1.272,-0.218 -2.708,-0.218l-1.2,-0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBSignIn);
export default __webpack_public_path__ + "static/media/iconB-sign-in.279e3148dfccd3aa329be4814d678496.svg";
export { ForwardRef as ReactComponent };